import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  UpdateGarageListing,
  AddServiceINQuickService,
  UpdateQuickServiceService,
  getCarBrand,
  getQuickServicesCategory,
  DeleteQuickServiceService,
  getQuickServicesListing,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';
import Swal from 'sweetalert2';

const QuickServicesParts = () => {
  const { t, i18n } = useTranslation();
  /* [CF 2026-08-17] Brand chips read `name || nameAr`, which is English-first
     whatever the site language — so an Arabic owner saw NISSAN, CHEVROLET,
     KIA. The brand master carries both spellings for all 108 brands, so it is
     only a matter of picking the one that matches the language. */
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const brandLabel = (brand) =>
    (isRTL ? brand?.nameAr || brand?.name : brand?.name || brand?.nameAr) || '';
  const dispatch = useDispatch();
  const home = useSelector((state) => state?.home);

  const CarBrandList = home?.garageCarBrandList;
  const categorylist = home?.getCategoryList;
  const getQuickServicesList = home?.getQuickServicesList;

  const [slected, setslected] = useState([{ id: '' }]);

  const [services, setservices] = useState([
    {
      service: '',
      carBrands: [],
    },
  ]);

  // [CF] The service input rows should only be visible while the owner is
  // actively adding a service. Hidden by default; toggled by "Add more
  // Services"; hidden again after a successful save. This stops the empty
  // input rows from lingering under the saved list (and overlapping on
  // mobile) once a service has been added.
  const [isAdding, setIsAdding] = useState(false);

  // [CF] Remembers WHICH saved service is currently being edited
  // (businessQuickServiceId). When set, submitting does a true in-place update
  // via the backend PUT instead of adding a new service. Cleared when the form
  // is reset or after a submit.
  const [editingQSId, setEditingQSId] = useState(null);

  const resetServiceRows = () => {
    setservices([{ service: '', carBrands: [] }]);
    setslected([{ id: '' }]);
    setEditingQSId(null);
  };

  const handleInputAdd = (e, indexValue) => {
    const { name, value } = e.target;
    const list = [...services];
    list[indexValue][name] = value;
    setservices(list);
  };

  const handleAddBrand = (e, i, Value, brandid) => {
    console.log(index1);

    const list = [...services];
    let SELECT_ARR = [...slected, brandid];

    if (list[index1].carBrands.includes(Value)) {
      list[index1].carBrands = list[index1].carBrands.filter(
        (brand) => brand !== Value
      );
    } else {
      list[index1].carBrands = [...services[index1].carBrands, Value];
    }

    if (slected.includes(brandid)) {
      SELECT_ARR = SELECT_ARR.filter((id) => id !== brandid);
    }

    setservices(list);
    setslected(SELECT_ARR);
  };

  const [index1, setIndex] = useState('');

  const handleRemoveClick = (index) => {
    const list = [...services];
    list.splice(index, 1);
    setservices(list);
  };
  const handleAddClick = (e) => {
    // First click opens the (hidden-by-default) input area with one empty row.
    // Subsequent clicks while already adding append another empty row.
    if (!isAdding) {
      setIsAdding(true);
      resetServiceRows();
      return;
    }
    setservices([
      ...services,
      {
        service: '',
        carBrands: [],
      },
    ]);
  };

  // [CF] Prefill the add-form from an existing saved service so the owner can
  // re-enter it with changes. We remember the businessQuickServiceId so saving
  // does a true in-place update (backend PUT) instead of creating a new entry.
  const onEditQuickService = (dt) => {
    const brandIds = (dt?.carBrands || [])
      .map((cb) => cb?.brand?.brandId ?? cb?.brandId)
      .filter((id) => id !== undefined && id !== null);
    setIsAdding(true);
    setEditingQSId(dt?.businessQuickServiceId ?? null);
    setservices([
      {
        service: dt?.quickService?.quickServiceId ?? dt?.quickServiceId ?? '',
        carBrands: brandIds,
      },
    ]);
    setslected([{ id: '' }, ...brandIds]);
  };

  /* [CF 2026-08-17] The service cards render from `getQuickServicesList`, which
     this page never fetched — it was only ever filled by the Manage Business
     page on the way in. Reaching this URL directly, or simply reloading it,
     therefore showed an empty page. Garage and A/C already fetch their own
     listing here; Quick Services was the one that did not.
     Keyed on `ownerBid` rather than read once at mount, because after a hard
     refresh the id arrives with /business/my a moment later — reading
     sessionStorage on the first render alone would fetch with `undefined`. */
  const getMybusiness = home?.getMybusiness;
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');

  useEffect(() => {
    dispatch(getCarBrand());
    dispatch(getQuickServicesCategory());
  }, [dispatch]);

  useEffect(() => {
    if (ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null') {
      dispatch(getQuickServicesListing(ownerBid));
    }
  }, [dispatch, ownerBid]);

  const datasubmit = (e) => {
    e.preventDefault();
    // The backend requires every service to have a non-empty STRING `service`
    // (a selected Service Type) and an array `carBrands`. Previously an
    // unselected type was sent as null, which the backend rejected for the
    // whole request with "Something is wrong". Keep only valid services and
    // give a clear message if none are selected.
    const validServices = services
      .filter((s) => s.service && String(s.service).trim())
      .map((s) => ({
        service: s.service,
        carBrands: Array.isArray(s.carBrands) ? s.carBrands : [],
      }));

    if (!validServices.length) {
      Swal.fire({
        title: t('Please select a service type before submitting'),
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: t('Ok'),
      });
      return;
    }

    if (editingQSId) {
      // [CF] In-place edit: update the existing saved service via the backend
      // PUT instead of adding a new one. We only edit one service at a time, so
      // use the first valid row.
      const edited = validServices[0];
      dispatch(
        UpdateQuickServiceService({
          services: [
            {
              businessQuickServiceId: editingQSId,
              service: edited.service,
              carBrands: edited.carBrands,
            },
          ],
        })
      );
    } else {
      dispatch(AddServiceINQuickService({ services: validServices }));
    }

    // [CF] Collapse the input rows after saving so they don't linger under the
    // saved-services list. The action refetches the list on success.
    // resetServiceRows() also clears editingQSId.
    setIsAdding(false);
    resetServiceRows();
  };

  const ResetHendler = () => {};

  console.log('categorylist', categorylist);

  const onDeleteQuickService = (businessId, businessQuickServiceId) => {
    // [CF-15] Confirm before deleting (was deleting instantly).
    Swal.fire({
      title: t('Are you sure?'),
      text: t('This item will be permanently deleted.'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('Yes, delete it'),
      cancelButtonText: t('Cancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          DeleteQuickServiceService({
            quickServiceOwnerId: businessId,
            businessQuickServiceId,
          })
        );
      }
    });
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-quick-services-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-quick-services-parts',
      label: t('Manage Services'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-quick-services-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-quick-services-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  const isPaymentPlanActive = sessionStorage.getItem('paymentPlan');

  return (
    <div>
      <CommonBusinessHeader
        dataList={getQuickServicesList}
        getNameKey="quickServiceOwnerName"
      />
      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <form onSubmit={datasubmit}>
                <h2 class="mb-4">{t('Manage Services')}</h2>
                <div class="row mb-2">
                  <div class="col-12">
                    <button
                      type="button"
                      id="btnAdd-2"
                      class="btn btn-warning"
                      onClick={handleAddClick}
                    >
                      {isAdding ? t('Add another row') : t('Add more Services')}
                    </button>
                    {isAdding && (
                      <button
                        type="button"
                        class="btn btn-secondary ml-2"
                        onClick={() => {
                          setIsAdding(false);
                          resetServiceRows();
                        }}
                      >
                        {t('Cancel')}
                      </button>
                    )}
                  </div>
                </div>

                {/* [CF] Service input rows render only while adding/editing. */}
                {isAdding &&
                  services.map((x, indexValue) => {
                  return (
                    <div id="example-2">
                      <div class="row group manage-services-row">
                        <div class="col-12 col-sm-12 col-md-4 mb-2 mb-sm-2 mb-md-0">
                          <label for="service-type" class="sr-only">
                            {t('Service Type')}
                          </label>
                          <select
                            class="form-control"
                            name="service"
                            value={x.service}
                            onChange={(e) => handleInputAdd(e, indexValue)}
                          >
                            <option> - {t('Service Type')} - </option>
                            {categorylist !== undefined && categorylist.length
                              ? categorylist.map((x) => {
                                  // console.log(x);
                                  return (
                                    <option value={x?.quickServiceId}>
                                      {t(x?.quickService || '')}
                                    </option>
                                  );
                                })
                              : ''}
                          </select>
                        </div>

                        <div class="col-12 col-sm-12 col-md-4 mb-2 mb-sm-2 mb-md-0">
                          <a
                            class="btn btn-outline-secondary"
                            href="javascript:void(0);"
                            role="button"
                            data-toggle="modal"
                            data-target="#add-car-brands-modal"
                            onClick={() => {
                              setIndex(indexValue);
                              // setslected([...slected,{id:''}])
                            }}
                          >
                            {t('Add Car Brands')}
                          </a>
                        </div>

                        <div class="col-12 col-sm-12 col-md-4">
                          {services.length !== 1 && (
                            <button
                              type="button"
                              class="btn btn-danger btnRemove"
                              onClick={() => handleRemoveClick(indexValue)}
                            >
                              {t('Remove')}
                            </button>
                          )}
                        </div>
                      </div>
                      <div
                        class="modal fade"
                        id="add-car-brands-modal"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-scrollable modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLabel">
                                {t('Car Brands')}
                              </h5>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="add-car-brands-wrap">
                                {/* <ul
                                  class="nav nav-pills mb-3"
                                  id="pills-tab"
                                  role="tablist"
                                >
                                  {CarBrandList !== undefined &&
                                  CarBrandList.length
                                    ? CarBrandList.map((item) => {
                                        return (
                                          <li class="nav-item">
                                            <a class="nav-link ">{item.area}</a>
                                          </li>
                                        );
                                      })
                                    : ''}
                                </ul> */}
                                <div class="tab-content">
                                  <div class="tab-pane fade show active nav-item">
                                    <div class="row ">
                                      {CarBrandList !== undefined &&
                                      CarBrandList.length
                                        ? CarBrandList?.map((item, index) => {
                                            return (
                                              <div class="col-6 col-sm-6 col-md-2 mb-4">
                                                <div
                                                  class="car-brands-block"
                                                  name="carBrands"
                                                  id={indexValue}
                                                  onClick={(e) =>
                                                    handleAddBrand(
                                                      e,
                                                      indexValue,
                                                      item?.brandId,
                                                      item?.brandId
                                                    )
                                                  }
                                                >
                                                  <div
                                                    class="car-brands-a "
                                                    style={{ color: 'yellow' }}
                                                    name="carBrands"
                                                    id={indexValue}
                                                    value={x.carBrands}
                                                  >
                                                    <img
                                                      id={indexValue}
                                                      style={{
                                                        opacity:
                                                          slected.includes(
                                                            item.brandId
                                                          )
                                                            ? '0.1'
                                                            : '',
                                                      }}
                                                      src={item?.media?.path}
                                                      class="img-fluid"
                                                      alt=""
                                                      onError={(e) => {
                                                        e.target.src =
                                                          'assets/images/car-brands/all.jpg';
                                                      }}
                                                    />
                                                  </div>

                                                  <div class="car-brands-b nav-item">
                                                    {/* [CF 2026-08-17] Was `NAME (nameAr)` - both spellings at once. Show the one that matches the site language. */}
                                                    {brandLabel(item)}
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })
                                        : ''}
                                      <hr />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn btn-primary "
                                data-dismiss="modal"
                              >
                                {t('Submit')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="row">
                  {/* [CF 2026-08-17] `list.length &&` puts a bare 0 on the page
                      when there are no services yet — JSX renders the number. */}
                  {getQuickServicesList?.length > 0 &&
                    getQuickServicesList?.[0]?.quickServices?.map((dt, ind) => {
                      return (
                        <div className="col-12 col-lg-6 mb-3" key={ind}>
                          {/* [FB2-#9c] Polished service card. Layout is driven by
                              INLINE styles (immune to CSS caching) so the action
                              buttons can NEVER overlap the name or the vehicle
                              chips — the two are in separate flex zones. */}
                          <div className="qs-svc-card">
                            <span className="qs-svc-accent" aria-hidden="true" />
                            <div style={{ flex: 1, minWidth: 0, padding: '14px 16px' }}>
                              {/* Row 1: name (left) + action buttons (right) */}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  justifyContent: 'space-between',
                                  gap: '10px',
                                }}
                              >
                                <div
                                  style={{
                                    fontWeight: 700,
                                    fontSize: '1.02rem',
                                    color: '#1d2229',
                                    minWidth: 0,
                                    overflowWrap: 'anywhere',
                                  }}
                                >
                                  {t(dt?.quickService?.quickService || '')}
                                </div>
                                <div
                                  style={{ display: 'flex', gap: '8px', flexShrink: 0 }}
                                >
                                  <button
                                    type="button"
                                    className="qs-icon-btn qs-icon-edit"
                                    title={t('Edit')}
                                    aria-label={t('Edit')}
                                    onClick={() => onEditQuickService(dt)}
                                  >
                                    <i className="far fa-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="qs-icon-btn qs-icon-del"
                                    title={t('Delete')}
                                    aria-label={t('Delete')}
                                    onClick={() =>
                                      onDeleteQuickService(
                                        dt?.businessId,
                                        dt?.businessQuickServiceId
                                      )
                                    }
                                  >
                                    <i className="far fa-trash-alt"></i>
                                  </button>
                                </div>
                              </div>

                              {/* Row 2: label */}

                              {/* Row 3: brand chips */}
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '6px',
                                }}
                              >
                                {/* Match the garage card exactly: brand chips only,
                                    and nothing at all when there are no brands
                                    (this used to add a grey "All Vehicles" chip,
                                    which is why quick services looked different). */}
                                {dt?.carBrands?.map((x, ci) => (
                                  <span className="qs-chip" key={ci}>
                                    {brandLabel(x?.brand)}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
                {/* <!-- Add Car Brands --> */}

                {/* [CF] Save button belongs to the add-form — show only while
                    adding/editing so it doesn't sit under the saved list. */}
                {isAdding && (
                <div class="row mt-5 ">
                  {/* <div class="col-6">
                    <button
                      type="reset"
                      onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      href="#"
                      // onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div> */}
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      class="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                      onSubmit={datasubmit}
                    >
                      {t('Save')}
                    </button>
                    {/* {isPaymentPlanActive == 'true' ? (
                    ) : (
                      <a
                        class="btn btn-warning btn-block"
                        href="#/manage-package"
                        role="button"
                      >
                        Buy Subscription
                      </a>
                    )} */}
                  </div>
                </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickServicesParts;
